// Ported 1:1 from src/lib/promotions.ts. Algorithm: eligible units (books
// whose genre is in the promo) → floor(qualifying / (paidPerFree + 1)) free
// units, assigned to the cheapest eligible units first.
const PROMO_TIMEZONE = "America/Sao_Paulo"

function todayIsoInTimeZone(date, timeZone) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date)
  const year = parts.find((p) => p.type === "year")?.value
  const month = parts.find((p) => p.type === "month")?.value
  const day = parts.find((p) => p.type === "day")?.value
  return `${year}-${month}-${day}`
}

export function isPromoActive(settings, now = new Date()) {
  if (!settings.active) return false
  if (!settings.endDate) return true
  return todayIsoInTimeZone(now, PROMO_TIMEZONE) <= settings.endDate
}

function hasPromoGenre(settings, genreIds) {
  return genreIds.some((id) => settings.genreIds.includes(id))
}

function emptyResult() {
  return { isActive: false, qualifyingUnits: 0, freeUnitCount: 0, freeUnitsByLineId: new Map(), discountTotal: 0 }
}

export function computePromoDiscount(settings, lines, now = new Date()) {
  if (!isPromoActive(settings, now)) return emptyResult()

  const qualifyingLines = lines.filter((line) => hasPromoGenre(settings, line.genreIds))
  const qualifyingUnits = qualifyingLines.reduce((sum, line) => sum + line.quantity, 0)
  const freeUnitCount = Math.floor(qualifyingUnits / (settings.paidPerFree + 1))

  if (freeUnitCount === 0) {
    return { ...emptyResult(), isActive: true, qualifyingUnits }
  }

  const units = []
  for (const line of qualifyingLines) {
    for (let i = 0; i < line.quantity; i++) units.push({ lineId: line.id, price: line.price })
  }

  const eligiblePool = units
    .filter((unit) => unit.price <= settings.freeItemMaxPrice)
    .sort((a, b) => a.price - b.price)

  const freeUnits = eligiblePool.slice(0, Math.min(freeUnitCount, eligiblePool.length))

  const freeUnitsByLineId = new Map()
  let discountTotal = 0
  for (const unit of freeUnits) {
    freeUnitsByLineId.set(unit.lineId, (freeUnitsByLineId.get(unit.lineId) ?? 0) + 1)
    discountTotal += unit.price
  }

  return {
    isActive: true,
    qualifyingUnits,
    freeUnitCount: freeUnits.length,
    freeUnitsByLineId,
    discountTotal,
  }
}
